const breakPoints = {
    sm: 576,
    md: 768, // Small tablets (portrait view)
    lg: 992, // Tablets and small desktops
    xl: 1600, // Large tablets and desktops
}

export default breakPoints; 